import braintree, { client } from 'braintree-web';
import { config } from 'src/config';

export const isApplePayAvailable = () => {
  return !!(
    window.ApplePaySession &&
    window.ApplePaySession?.supportsVersion(3) &&
    window.ApplePaySession?.canMakePayments()
  );
};

export const mapPaySourceToPaymentType = (
  paySource: string | null | undefined,
) => {
  if (!paySource) {
    return '';
  }

  switch (paySource.toUpperCase()) {
    case 'CREDITCARD':
      return 'credit_card';
    case 'PAYPAL':
      return 'paypal';
    default:
      return '';
  }
};

export const isGooglePayAvailable = async () => {
  try {
    const paymentsClient = new google.payments.api.PaymentsClient({
      environment: 'PRODUCTION',
    });

    const clientInstance = await client.create({
      authorization: config.BR_KEY,
    });

    const googlePaymentInstance: any = await new Promise((resolve, reject) => {
      braintree.googlePayment.create(
        {
          client: clientInstance,
          googlePayVersion: 2,
          googleMerchantId: config.BR_ID,
        },
        (err, instance) => {
          if (err) {
            reject(err);
          } else {
            resolve(instance);
          }
        },
      );
    });

    const isReadyToPay = await paymentsClient.isReadyToPay({
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods:
        googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
      existingPaymentMethodRequired: true,
    });

    return {
      isReadyToPayResult: isReadyToPay.result,
    };
  } catch (e) {
    return {
      isReadyToPayResult: false,
    };
  }
};

export const showExpressButtons = async ({
  googleEnabled,
  appleEnabled,
}: {
  googleEnabled: boolean;
  appleEnabled: boolean;
}) => {
  let applePayAvailable = false;
  let googlePayAvailable = false;

  if (appleEnabled) {
    applePayAvailable = isApplePayAvailable();
  }

  if (googleEnabled && !applePayAvailable) {
    const googlePayData = await isGooglePayAvailable();
    googlePayAvailable = googlePayData.isReadyToPayResult;
  }

  return {
    applePayAvailable,
    googlePayAvailable,
  };
};
